import { resolveVendorDirectoryApiBase } from "./clientPortalFetch.js";

function authHeaders() {
  return { "Content-Type": "application/json" };
}

export async function getVendorDirectorySettings(clientViewId) {
  const response = await fetch(`${resolveVendorDirectoryApiBase(clientViewId)}/configuracion`, {
    credentials: "include",
    headers: authHeaders(),
  });
  const body = await response.json();
  if (!response.ok) throw new Error(body.error || "No se pudo cargar la configuración.");
  return body;
}

export async function updateVendorDirectorySettings(clientViewId, payload) {
  const response = await fetch(`${resolveVendorDirectoryApiBase(clientViewId)}/configuracion`, {
    method: "PATCH",
    credentials: "include",
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  const body = await response.json();
  if (!response.ok) throw new Error(body.error || "No se pudo guardar la configuración.");
  return body;
}

export async function previewVendorDirectorySettings(clientViewId, payload) {
  const response = await fetch(`${resolveVendorDirectoryApiBase(clientViewId)}/configuracion/preview`, {
    method: "POST",
    credentials: "include",
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  const body = await response.json();
  if (!response.ok) throw new Error(body.error || "No se pudo generar la vista previa.");
  return body;
}
